import Modal from "react-modal";
import AgoraChatMobile from "../../../agora-chat-mobile";
import { useSwipeable } from "react-swipeable";
import { useState } from "react";
import { close } from "../../../../assets/icons";
import useAppAccessor from "../../../../hooks/useappAccessor";

const customStyles = {
  content: {
    top: "30%",
    left: 0,
    right: 0,
    border: 0,
    bottom: 0,
    borderRadius: 20,
    backgroundColor: "#303030",
  },
  overlay: {
    backgroundColor: "rgba(24, 24, 24,0.5)",
    zIndex: 99999,
  },
};

function ModalBottomChatMobile(props: any) {
  const { getControls} = useAppAccessor();
const {
  roleCopresenter,
} = getControls();

  return (
    <div className="flex" style={roleCopresenter ? {overflow:'hidden', position:'absolute', bottom: '20px', width:'100%', height:'70%'} : {overflow:'hidden', position:'absolute', bottom: '-10px', width:'100%', height:'70%'}}>
      <div style={{marginTop:'15px', overflow:'hidden', width:'100%', height:'100%'}}>
        <AgoraChatMobile 
          setModalBottom={props.setModalBottom} 
          setInteractionsBottom={props.setInteractionsBottom} 
          modalIsOpen={props.modalIsOpen}
          onMessagesChange={props.onMessagesChange}
        ></AgoraChatMobile>
      </div>
  </div>
  );
}

export default ModalBottomChatMobile;
